import React from "react";
import { Container } from "reactstrap";

import Credit from "./Credit";

export default class Credits extends React.Component {
  render() {
    return (
      <Container className="text-center">
        <h1 className="display-2 marble-black-text">Credits</h1>
        <h2>
          I wanted to thank some people for the resources I used in this website
        </h2>
        <Credit
          title="Nicolas Baier"
          link="https://nicolasbaier.com/"
          image={require("../../assets/images/baier_34_trou_noir.jpg")}
          imageLink="https://nicolasbaier.com/portfolio/traces/"
          alt="Nicolas Baier - Trou Noir"
          desc={
            <p className="lead text-left mt-3">
              Trou noir/Black hole, 2005
              <br />
              Épreuve au jet d’encre, acrylique, acier/Ink jet print, acrylic,
              steel
              <br />
              109 x 145 cm
              <br />
              Galerie Division Montreal, Toronto & New York
            </p>
          }
        />

        <Credit
          title="Bitmoji"
          link="https://www.bitmoji.com/"
          image={require("../../assets/images/bitmojis/bitmoji3.png")}
          alt="My bitmoji"
          desc={<p className="lead mt-3">May the force be with you</p>}
        />
      </Container>
    );
  }
}

Credits.propTypes = {};
